import {
  BasketballUserUpcomingLeagueData,
  ResponseBasketballGetUserUpcomingLeagueData,
} from '@hefe/models';
import {
  createAsyncThunk,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import API from '../../../api/api';

const FEATURE_KEY = 'basketballUser';

/************************************************************************************
 *
 *                                  ACTIONS
 *
 ************************************************************************************
 */
const fetchBasketballUserUpcomingLeagueData = createAsyncThunk(
  'basketballUser/getUpcomingLeagueData',
  async (thunkAPI) => {
    const response = await API.basketballUser().getUpcomingLeagueData();
    return response?.data;
  }
);

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

export interface BasketballUserState {
  upcomingLeagueData: BasketballUserUpcomingLeagueData[]; // Change
}

const initialState: BasketballUserState = {
  upcomingLeagueData: [],
};

const BasketballUserSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchBasketballUserUpcomingLeagueData.fulfilled,
      (
        state: BasketballUserState,
        action: PayloadAction<ResponseBasketballGetUserUpcomingLeagueData>
      ) => {
        state.upcomingLeagueData = action.payload;
      }
    );
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = BasketballUserSlice.reducer;
const actions = BasketballUserSlice.actions;

const state = (rootState: any): BasketballUserState => rootState[FEATURE_KEY];

const basketballUserUpcomingLeagueDataSelector = createSelector(
  state,
  (state) => {
    return state.upcomingLeagueData;
  }
);

export {
  actions,
  reducer,
  fetchBasketballUserUpcomingLeagueData,
  basketballUserUpcomingLeagueDataSelector,
};
